import React from "react";
import { FaInstagram, FaLinkedin, FaWhatsapp } from "react-icons/fa6";
import SomeGood from "../../assets/partners/some_good.png";
import Bluethree from "../../assets/partners/Bluetree.png";
import Merchant from "../../assets/partners/merchant.png";
import KATHA from "../../assets/partners/KATHA.jpg";
import SBRS from "../../assets/partners/SBRS.jpg";
import BAY from "../../assets/partners/BAY.jpg";
import Stu from "../../assets/partners/stu.png";
import Four from "../../assets/partners/four.svg";

import Natiya from "../../assets/yash.jpg";
import Aryan from "../../assets/aryan.jpg";
import "./partners.css";

const Partners = () => {
  return (
    <div className="partner_main">
      <p className="team_info_head">PARTNERS</p>

      <div className="partners_main">
        <div className="img_p">
          <img src={SomeGood} alt="ashish" className="partner-img" />
        </div>
        <div className="img_p">
          <img src={Bluethree} alt="logo" className="partner-img" />
        </div>
        <div className="img_p">
          <img src={Merchant} alt="logo" className="partner-img" />
        </div>
        <div className="img_p">
          <img src={Four} alt="fatrta" className="partner-img" />
        </div>
      </div>
      <p className="team_info_head">PRONITES TEAM</p>
      <div className="team_info">
        <div className="cg_detail_mul">
          <div className="mul_cg_de_main">
            <div className="img">
              <img src={Natiya} alt="krishna" />
            </div>
            <div className="mul_cg_de">
              <p className="mul_cg_name">Yog Sonawane</p>
              <p className="mul_cg_depa">Pronites Head</p>
              <a href="tel:+91 79770 58957" className="cg_phone_mul">
                +91 79770 58957
              </a>
              <div className="cg_mul_cont">
                <a
                  href="https://www.instagram.com/yog.sonawane?igsh=MWJnNjJkN3JvOHB2Nw=="
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram
                    color="black"
                    size={window.innerWidth > 770 ? 30 : 40}
                  />
                </a>
                <a
                  href="https://www.linkedin.com/in/yog-sonawane-2b5159310?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin
                    color="black"
                    size={window.innerWidth > 770 ? 30 : 40}
                  />
                </a>
                <a
                  href="https://wa.me/7977058957"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp
                    color="black"
                    size={window.innerWidth > 770 ? 30 : 40}
                  />
                </a>
              </div>
            </div>
          </div>
          <div className="mul_cg_de_main ext_leena">
            <div className="img">
              <img src={Aryan} alt="leena" />
            </div>
            <div className="mul_cg_de ">
              <p className="mul_cg_name">Ranbir Sinha</p>
              <p className="mul_cg_depa">Pronites Head</p>
              <a href="tel:+919137622913" className="cg_phone_mul">
                +91 91376 22913
              </a>
              <div className="cg_mul_cont">
                <a
                  href="https://www.instagram.com/ranbirsinhaaa?igsh=NnFsejh2aGhsNTVr&utm_source=qr"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram
                    color="black"
                    size={window.innerWidth > 770 ? 30 : 40}
                  />
                </a>
                <a
                  href="http://www.linkedin.com/in/ranbir-sinha-aab655283"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedin
                    color="black"
                    size={window.innerWidth > 770 ? 30 : 40}
                  />
                </a>
                <a
                  href="https://wa.me/9137622913"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp
                    color="black"
                    size={window.innerWidth > 770 ? 30 : 40}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partners;
